module.exports = __webpack_public_path__ + "static/slider-2-1-4d12330cdb2618c6bc8de518a89c3517.webp";